// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    dirty: false,
    raw: "4bef0ae",
    hash: "4bef0ae",
    distance: null,
    tag: null,
    semver: null,
    suffix: "4bef0ae",
    semverString: null,
    subenv: null,
    rev_count: "1"
};
/* tslint:enable */
